<ng-container *ngIf="programService.currentProgramEnrollmentObject.id">
  <ng-container *ngComponentOutlet="patientNoteComponent;injector: custom_injector;"></ng-container>
</ng-container>

